<template>
  <div class="card-cta card-cta--sidebar">
    <!-- Text -->
    <div class="card-cta__content">
      <span class="d-block h6 mb-2">{{ currentStepTitle }}</span>
      <a href="tel:0318571382" class="btn btn--primary btn--sm">
        <i class="icon icon-phone ms-0 me-1"></i>
        0318 571 382
      </a>
    </div>

    <!-- Image -->
    <div class="card-cta__img">
      <img
        src="/resources/assets/images/arjen_sidebar.png"
        alt=""
        loading="lazy"
      />
    </div>
  </div>
</template>

<script>
import { flowConfig } from '../config/flowConfig.js';

export default {
  name: 'SidebarCta',
  props: {
    flowType: {
      type: String,
      required: true,
    },
    currentStep: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    currentStepTitle() {
      const config = flowConfig[this.flowType];
      if (!config || !Array.isArray(config.steps)) return '';
      const step = config.steps[this.currentStep];
      return step?.ctaTitle || 'Kunnen wij je helpen?';
    },
  },
  watch: {},
  methods: {},
};
</script>
